import { performGetRequest } from '@atlassian/jira-fetch';
import { logErrorAndFireAnalytics } from '@atlassian/jira-software-code-commons';

export const BITBUCKET_PRODUCT_NAME = 'com.atlassian.bitbucket';

export const getXFlowEndPoint = () => '/gateway/api/xflow';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const doOnError = (error: any) => {
	logErrorAndFireAnalytics({
		packageName: 'jiraSoftwareCodePage',
		locationId: 'services.one-click-connect.connect-to-bitbucket',
		message: 'Could not fetch license information.',
		error,
	});
};

const getLicenseInformation = (cloudId: string) =>
	performGetRequest(`${getXFlowEndPoint()}/${cloudId}/license-information`);

export const hasBitbucketProvisioned = async (cloudId: string) => {
	try {
		const data = await getLicenseInformation(cloudId);
		if (
			data &&
			data.products &&
			data.products[BITBUCKET_PRODUCT_NAME] &&
			data.products[BITBUCKET_PRODUCT_NAME].state
		) {
			return data.products[BITBUCKET_PRODUCT_NAME].state === 'ACTIVE';
		}
		return false;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (err: any) {
		doOnError(err);
		throw err;
	}
};
